interface ProfileFieldItem {
  profilekey: number;
  fieldposition: number;
  itemposition: number;
  title: string;
}

/** Item title to specify that dropdown text field can have arbitrary text. */
export const WILDCARD_FIELD_ITEM = '*';

export interface ProfileFieldItemAttributes {
  title: string;
}

export default ProfileFieldItem;
